/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import CircleButton from '../CircleButton';
import styles from './styles.sass';

// / TODO (bui): clean the svg pause path
const PlayButton = ({
  colors: { colorClass },
  className = '',
  disabled,
  iconColors: { color: iconColor },
  isPlaying,
  onClick,
  size = 36,
  iconSize = 18,
  ariaLabel = '',
  shouldShowStopButtonInsteadOfPause = false,
}) => {
  function renderPlayButtonContent() {
    if (isPlaying) {
      return shouldShowStopButtonInsteadOfPause ? (
        <div
          css={css`
            background-color: #fff;
            width: 10px;
            height: 10px;
            border-radius: 0.5;
          `}
        />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 12 12"
          width={iconSize}
          height={iconSize}
        >
          <rect x=".03" width="12" height="12" fill="none" />
          <path
            d="M8.45 0h1.83a.75.75 0 0 1 .72.75v10.5a.75.75 0 0 1-.75.75h-1.8a.75.75 0 0 1-.75-.75V.75A.75.75 0 0 1 8.45 0zM1.78 0h1.83a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75H1.78a.76.76 0 0 1-.78-.75V.75A.76.76 0 0 1 1.78 0z"
            fill={iconColor}
          />
        </svg>
      );
    }
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-1 0 11 12"
        width={iconSize}
        height={iconSize}
      >
        <rect width="12" height="12" fill="none" />
        <path
          d="M1 .81v10.38a.76.76 0 0 0 .75.75.67.67 0 0 0 .39-.12l8.42-5.18a.75.75 0 0 0 0-1.28L2.14.18a.75.75 0 0 0-1 .24.79.79 0 0 0-.14.39z"
          fill={iconColor}
        />
      </svg>
    );
  }
  return (
    <CircleButton
      baseColor={colorClass}
      onClick={onClick}
      size={size}
      disabled={disabled}
      className={`${styles.playButton} ${className}`}
      ariaLabel={ariaLabel}
    >
      {/* Pause and Plus SVGs */}
      {renderPlayButtonContent()}
    </CircleButton>
  );
};

PlayButton.defaultProps = {
  colors: { colorClass: 'gray' },
  iconColors: { color: '#fff' },
  className: '',
  disabled: false,
  isPlaying: false,
  size: 36,
  iconSize: 18,
  ariaLabel: '',
};

PlayButton.propTypes = {
  colors: PropTypes.shape({
    color: PropTypes.string,
    colorClass: PropTypes.string,
    colorDark: PropTypes.string,
    colorLight: PropTypes.string,
  }),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  iconColors: PropTypes.shape({
    color: PropTypes.string,
    colorClass: PropTypes.string,
    colorDark: PropTypes.string,
    colorLight: PropTypes.string,
  }),
  isPlaying: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.number,
  iconSize: PropTypes.number,
  ariaLabel: PropTypes.string,
};

export default PlayButton;
